//core
import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import html2pdf from "html2pdf.js";

//components
import MainLayout from "../../../../Layouts/Main";
import CardHero from "Components/CardHero";
import PieChart from "Components/PieChart";

//redux
import { useDispatch, useSelector } from "react-redux";
import { getAssessmentSubCategoryDetails_USER } from "../../../../Redux/Slices/User/userSlice";
import { getSpareParts } from '../../../../Redux/Slices/Accessor/accessorSlice';

//assets
import BackArrow from "../../../../Assets/Svg/Auth/BackArrow.svg";

import PDFIcom from "../../../../Assets/Images/pdfImg.png";
import DocIcon from "../../../../Assets/Images/doc.png";
import ExcelIcon from "../../../../Assets/Images/xlsx.png";
// import kgLogoEvidence from "../../../../Assets/Images/kgLogoEvidence.png";

//styles
import "./styles.scss";
import Button from "Components/Button";

import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import firstPage from "../../../../Assets/Images/pdfFirstPage.jpg";
import FooterColorLineData from "Services/data/footerColorLineData";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import ImageModal from "Components/ImageModal";

function AssessmentDetails() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const contentRef = useRef();

  const { assessmentId, subCategoryId } = useParams();
  const [subCategoryDetails, setSubCategoryDetails] = useState({
    performance_results: [],
  });
  const [sparePartData, setSparePartData] = useState(null);
  const [selectedSparePart, setSelectedSparePart] = useState(null);
  const isLoading = useSelector((state) => state.user.isLoading);
  const [showLoader, setShowLoader] = useState(false);
  useEffect(() => {
    dispatch(
      getAssessmentSubCategoryDetails_USER({
        reportId: assessmentId,
        subCategoryId: subCategoryId,
        callBack: setDetails,
      })
    );
    dispatch(
      getSpareParts({ assessment_id: assessmentId, callBack: setSparePartDataAndLoading })
    )
  }, []);

  const setDetails = (data) => {
    setSubCategoryDetails(data.data);
    if (
      data.data?.performance_results &&
      data.data.performance_results.length > 0
    ) {
    } else {
    }
  };


  const handleBackClick = () => {
    navigate(-1);
  };

  const setSparePartDataAndLoading = (data) => {
    setSparePartData(data)
  }

  useEffect(() => {
    if (Array.isArray(sparePartData) && subCategoryId) {
      const selected = sparePartData.find(
        (item) => item.log_id?.toString() === subCategoryId.toString()
      );
      setSelectedSparePart(selected || null);
    }
  }, [sparePartData, subCategoryId]);



  return (
    <MainLayout>
      <div className="assessment-detail-container">
        <div className="assessment-header">
          <h2 className="assessment-title">
            <span>
              <img
                src={BackArrow}
                alt="backArrow"
                width="25px"
                height="28px"
                onClick={handleBackClick} // Go back in history
                style={{ marginBottom: "4px", cursor: "pointer" }}
              />
            </span>
            {isLoading === 'loading' ? (
              <Skeleton height={30} width={200} style={{ marginLeft: "10px" }} />
            ) : (
              subCategoryDetails?.assessment_details?.assessment_name || "N/A"
            )}
          </h2>
          {/* <Button
            title={showLoader ? "Downloading..." : "Download as PDF"}
            buttonStyle={downloadButton}
            onClick={()=>{
              setShowLoader(true);
              handleDownloadPDF()}}
            titleStyle={downloadTitle}
          /> */}
        </div>
        <div ref={contentRef}>
          <div className="card-hero-container">
            {isLoading === 'loading' ? (
              <Skeleton count={1} height={200} />
            ) : (<CardHero
              headingName={
                subCategoryDetails.performance_results[0]?.category_name || "N/A"
              }
              details={"This score is based on the assessment you have attended"}
              rating={
                subCategoryDetails.performance_results[0]?.average_score
                  ? Number(subCategoryDetails.performance_results[0].average_score).toFixed(0)
                  : "N/A"
              }
              wrap={true}
            />)}</div>

          <div className="scores-container my-4">
            {isLoading === 'loading' ? (
              <>
                <Skeleton count={1} height={200} />
                <Skeleton count={1} height={200} />
                <Skeleton count={1} height={200} />
              </>
            ) : (
              subCategoryDetails.performance_results[0]?.sub_categories.map(
                (item, index) => {
                  const performanceRating = !isNaN(Number(item.average_score))
                    ? Number(item.average_score).toFixed(0)
                    : "N/A";

                  const color = performanceRating !== "N/A" && Number(performanceRating) < 50
                    ? "#ff352e"  // Red if less than 50
                    : "#02cf35"; // Green otherwise

                  return (
                    <div key={index} className="score-item">
                      <PieChart
                        headingName={item.subCategory_name}
                        performanceRating={
                          !isNaN(Number(item.average_score))
                            ? Number(item.average_score).toFixed(0)
                            : "N/A"
                        }
                        color={color}
                      />
                    </div>
                  );
                }
              )
            )}
          </div>

          <div className="insights-container my-4">
            <h2>Insight</h2>
            <div className="insight-list">
              {isLoading === 'loading' ? (
                <Skeleton count={4} height={28} style={{ marginBottom: "10px" }} />
              ) : subCategoryDetails.researchData && subCategoryDetails.researchData.length > 0 ? (
                subCategoryDetails.researchData.map((item, index) => (
                  item.insights ? (
                    <div
                      key={index}
                      className="insight-item"
                      dangerouslySetInnerHTML={{ __html: item.insights }}
                    />
                  ) : null
                ))
              ) : (
                <p>No insights available.</p>
              )}
            </div>
          </div>

          <div className="evidence-container my-4">
            <div className="evidence-heading">
              <div className="evidence-heading-details">
                <h4>Assessment References</h4>
                <h6>Captured images from your company</h6>
              </div>
              {/* <div>
                <img src={kgLogoEvidence} alt="logo" />
              </div> */}
            </div>

            <div className="evidence-grid">
              {isLoading === 'loading' ? (
                <Skeleton count={4} height={40} />
              ) : subCategoryDetails.researchData &&
                subCategoryDetails.researchData.length > 0 &&
                subCategoryDetails.researchData.some(
                  (item) =>
                    item.upload && item.upload.some((url) => /\.(jpg|jpeg|png)$/i.test(url))
                ) ? (
                subCategoryDetails.researchData.map((item, index) =>
                  item.upload && Array.isArray(item.upload) ? (
                    item.upload.map((url, imgIndex) => {
                      const isImage = /\.(jpg|jpeg|png|gif)$/i.test(url);
                      return isImage ? (
                        <div
                          key={`${index}-${imgIndex}`}
                          className={
                            imgIndex % 2 === 1
                              ? "evidence-grid-item-span-2"
                              : "evidence-grid-item"
                          }
                        >
                          {/* <img
                              className="grid-image"
                              src={url}
                              alt={`evidence ${index + 1}-${imgIndex + 1}`}
                            /> */}
                          <ImageModal src={url} alt={`evidence ${index + 1}-${imgIndex + 1}`} />
                        </div>
                      ) : null;
                    })
                  ) : null
                )
              ) : selectedSparePart?.photos?.length > 0 ? (
                <div
                  className="evidence-grid-item"
                >
                  <ImageModal src={selectedSparePart?.photos[0]?.url} />
                </div>
              ) : (
                <p>No Image available.</p>
              )

              }
            </div>

            <div className="evidence-pdf">
              <div className="evidence-pdf-details">
                <h4 style={{ color: "black", fontWeight: "700" }}>Documents</h4>
                <h6 style={{ fontWeight: "600" }}>
                  All formats of important documents from your company
                </h6>
                <div className="evidence-pdf-container">
                  {isLoading === "loading" ? (
                    <Skeleton count={3} height={40} />
                  ) : subCategoryDetails.researchData &&
                    subCategoryDetails.researchData.some((item) =>
                      Array.isArray(item.upload) &&
                      item.upload.some((url) => /\.(pdf|docx|doc|xls|xlsx)$/i.test(url))
                    ) ? (
                    subCategoryDetails.researchData.map((item, index) =>
                      item.upload && Array.isArray(item.upload)
                        ? item.upload.map((url, imgIndex) => {
                          if (!url) return null;

                          const isPDF = /\.pdf$/i.test(url);
                          const isDoc = /\.(docx|doc)$/i.test(url);
                          const isExcel = /\.(xlsx|xls)$/i.test(url);

                          return (
                            <React.Fragment key={`${index}-${imgIndex}`}>
                              {isPDF && (
                                <div className="individual-pdf-container">
                                  <a href={url} target="_blank" rel="noopener noreferrer">
                                    <img src={PDFIcom} alt="PDF" width="75px" height="auto" />
                                    <p>Open PDF</p>
                                  </a>
                                </div>
                              )}
                              {isDoc && (
                                <div className="individual-pdf-container">
                                  <a href={url} target="_blank" rel="noopener noreferrer">
                                    <img src={DocIcon} alt="DOC" width="75px" height="auto" />
                                    <p>Open DOC</p>
                                  </a>
                                </div>
                              )}
                              {isExcel && (
                                <div className="individual-pdf-container">
                                  <a href={url} target="_blank" rel="noopener noreferrer">
                                    <img src={ExcelIcon} alt="Excel" width="75px" height="auto" />
                                    <p>Open Excel</p>
                                  </a>
                                </div>
                              )}
                            </React.Fragment>
                          );
                        })
                        : null
                    )
                  ) : (
                    <p>-</p>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="insights-container my-4">
            <h2>Recommendations</h2>
            {isLoading === 'loading' ? (
              <Skeleton count={4} height={28} style={{ marginBottom: "10px" }} />
            ) : subCategoryDetails.recommendations &&
              subCategoryDetails.recommendations.length > 0 ? (
              <div className="recommendations-list">
                {subCategoryDetails.recommendations.map((recommendation, index) =>
                  recommendation.message ? (
                    <div
                      key={index}
                      className="insight-item"
                      dangerouslySetInnerHTML={{ __html: recommendation.message }}
                    />
                  ) : null
                )}
              </div>
            ) : (
              <p>No recommendations available.</p>
            )}
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default AssessmentDetails;
